import React from 'react';
import { Stethoscope, Syringe, Shield, HeartPulse, PawPrint, Activity, Scan, Eye, Heart, Radio, Bird, Droplet, Wind, Smile, Cat, Bone } from 'lucide-react';
import { services, specialties } from '../data/mock';

const iconMap = {
  'stethoscope': Stethoscope,
  'syringe': Syringe,
  'shield': Shield,
  'heart-pulse': HeartPulse,
  'paw-print': PawPrint,
  'activity': Activity,
  'scan': Scan,
  'eye': Eye,
  'heart': Heart,
  'radio': Radio,
  'bird': Bird,
  'droplet': Droplet,
  'wind': Wind,
  'smile': Smile,
  'cat': Cat,
  'bone': Bone
};

const Services = () => {
  return (
    <section id="servicios" className="py-20 bg-gradient-to-b from-white to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block">
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Nuestros Servicios</span>
            <div className="h-1 w-20 bg-teal-500 mt-2 rounded-full mx-auto"></div>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Servicios Veterinarios
          </h2>
          
          <p className="text-lg text-gray-600">
            Ofrecemos una gama completa de servicios veterinarios para cuidar la salud y bienestar de tu mascota.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Specialties Section */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Especialidades
            </h3>
            <p className="text-lg text-gray-600">
              Contamos con profesionales especializados en diversas áreas
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {specialties.map((specialty) => {
              const Icon = iconMap[specialty.icon];
              return (
                <div
                  key={specialty.id}
                  className="group bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-teal-100 text-center"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h4 className="text-sm font-bold text-gray-900 group-hover:text-teal-600 transition-colors">
                    {specialty.title}
                  </h4>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                ¿Necesitás una consulta?
              </h3>
              <p className="text-gray-600">
                Estamos acá para ayudarte. Contactanos y agendá tu turno.
              </p>
            </div>
            <button
              onClick={() => window.open(`https://wa.me/5491162573889?text=Hola! Me gustaría agendar una consulta.`, '_blank')}
              className="px-8 py-4 bg-teal-500 text-white font-semibold rounded-xl hover:bg-teal-600 transition-colors duration-200 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Agendar Turno
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;